import script from "./FriendsView.vue?vue&type=script&setup=true&lang=js"
export * from "./FriendsView.vue?vue&type=script&setup=true&lang=js"

import "./FriendsView.vue?vue&type=style&index=0&id=07f9d0d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07f9d0d7"]])

export default __exports__